import { api } from '@/helpers/api'
import { store } from '@/store'
import risks from '@/helpers/risks'

const checkActive = risk => new Date(risk.end_date).getTime() >= Date.now()

async function getList (number, loadImages) {

  const animals = (await api.get('legacy/api/v1/portal/animal/' + number)).data.data

  store.commit('canSubmitInvoice', false)
  store.commit('canSubmitClaim', false)

  animals.forEach(animal => {
    animal.risks.forEach(risk => {
      if (risk.is_active) {
        if (risks.canSubmitInvoice(risk.type)) {
          store.commit('canSubmitInvoice', true)
        }
        
        if (risks.canSubmitClaim(risk.type)) {
          store.commit('canSubmitClaim', true)
        }
      }
    })

  })

  if (loadImages) {
    try {
      const { data: list } = await api.get('upload/private/list')

      for (let i = 0; i < animals.length; i++) {
        const key = 'avatar' + String(animals[i].identifier).slice(-4)

        if (!list.some(e => e.key === key)) continue

        try {
          const res = await api.get('upload/private?key=' + key)

          animals[i].image = res.data.data
        } catch (e) {
          console.error(e)
        }
      }
    } catch (e) {
      console.error(e)
    }
  }
   
  return {
    data: animals,
    count: animals.length
  }
}

async function getActiveList (number, loadImages) {
  const result = await this.getList(number, loadImages)

  return result ? {
    data: result.data.filter(item => {
      return item.risks.some(checkActive)
    }),
    count: result.data.length
  } : result
}

async function getSplittedList (number, loadImages) {
  const result = await this.getList(number, loadImages)

  return result ? {
    active: result.data.filter(item => {
      return item.risks.every(checkActive)
    }),
    inactive: result.data.filter(item => {
      return !item.risks.every(checkActive)
    }),
    count: result.data.length
  } : result
}

async function setImage (identifier, data) {
  return await api.post('upload/private', { key: 'avatar' + String(identifier).slice(-4), data })
}

export default {
  getList,
  getActiveList,
  getSplittedList,
  setImage
}